function tagDescontoPix() {
  const listHomeProds = wsMain?.globalData?.listHomeProds?.produtos;
  const listGroupProds = wsMain?.globalData?.listGroupProds?.grupos;
  const relatedProds = wsMain?.globalData?.listRelatedProds
  const lastProds = wsMain?.globalData?.listLastProds
  const listCategoryProds = wsMain?.globalData?.listCategoryProds?.produtos;
  const infoProduct = wsMain?.globalData?.infoProduto;
  const allProducts = [];

  if (infoProduct) {
    allProducts.push(infoProduct);
  }

  if (relatedProds  && relatedProds.length > 0) {
    allProducts.push(...relatedProds)
  }

   if (lastProds  && lastProds.length > 0) {
    allProducts.push(...lastProds)
  }

  if (listHomeProds && listHomeProds.length > 0) {
    listHomeProds.forEach((prod) => {
      allProducts.push(prod);
    });
  }

  if (listGroupProds && listGroupProds.length > 0) {
    listGroupProds.forEach((group) => {
      if (group.produtos && group.produtos.length > 0) {
        group.produtos.forEach((prod) => {
          allProducts.push(prod);
        });
      }
    });
  }

  if (listCategoryProds && listCategoryProds.length > 0) {
    listCategoryProds.forEach((prod) => {
      allProducts.push(prod);
    });
  }
  console.log(allProducts)
  if (!allProducts || allProducts.length === 0) {
    return;
  }

  if(infoProduct) {
    if (!infoProduct.precos?.desconto_avista) return;
    const tagDescontoPix = document.querySelector(".row .tagDescontoPix");
    if(tagDescontoPix) {
    tagDescontoPix.innerHTML = `no PIX`;
   }
  }

  allProducts.forEach((prod) => {
    if (!prod.precos?.desconto_avista) return;
    const prodsElements = document.querySelectorAll(
      `[ws-prod-sku="${prod.codigo}"]`
    );
    prodsElements.forEach(prodElement => {
    const tagDescontoPix = prodElement.querySelector(".tagDescontoPix");
    tagDescontoPix.innerHTML = `no PIX`;
    })
  });
} 

function customBannerSize() {
  const banners = [
    document.querySelector("#banner-advanced3"),
    document.querySelector("#banner-advanced4")
  ];

  const slides = [
    document.querySelector('[data-wsjs-id="prodSlide-6"] .keen-slider__slide'),
    document.querySelector('[data-wsjs-id="prodSlide-7"] .keen-slider__slide')
  ];

  const titles = [
    document.querySelector('[data-wsjs-id="prodSlide-6"] .prod-list-titles'),
    document.querySelector('[data-wsjs-id="prodSlide-7"] .prod-list-titles')
  ];

  const dots = [
    document.querySelector('[data-wsjs-id="prodSlide-6"] .dots'),
    document.querySelector('[data-wsjs-id="prodSlide-7"] .dots')
  ];

  banners.forEach((bannerEl, index) => {
    const slideEl = slides[index];
    const titleEl = titles[index];
    const dotsEl = dots[index];

    if (!bannerEl || !slideEl || !titleEl || !dotsEl) return;

    bannerEl.style.height = `calc(${slideEl.offsetHeight}px - 2px)`;

    const bannerWidth = bannerEl.offsetWidth;

    titleEl.style.width = `calc(100% - ${bannerWidth}px - 20px)`;
    dotsEl.style.width = `calc(100% - ${bannerWidth}px - 20px)`;
  });
}
  window.addEventListener("resize", customBannerSize);
try {
  isReady("product-list", () => {
    setTimeout(() => {
       customBannerSize();
    }, 500);
  });
} catch (error) {
  console.error(error);
}



try {
    isReady("product-list", tagDescontoPix)
} catch (error) {}

try {
    isReady("pag-produto", tagDescontoPix)
} catch (error) {}

function customUnavaliable() {
  function createCustomUnavaliableModal() {
    const verify = document.querySelector(".custom-modal-unavaliable");

    if (verify) return;

    const modal = document.createElement('div')
    modal.classList.add('custom-modal-unavaliable')
    modal.innerHTML = `
    <div class="custom-modal-unavaliable__bg"></div>
        <div class="custom-modal-unavaliable__content">
          <div class="custom-modal-unavaliable__content__title-container">
          
          </div>
          <div class="custom-modal-unavaliable__content__form-container">
            <div class="form__image-container">
              
            </div>
            <div class="form__form-container">
            <div class="titleModalUnavaliable">
              <h3>Nome do produto</h3>
                              <div class="modal-unavaliable__content__close"><svg xmlns="http://www.w3.org/2000/svg" width="14.828" height="14.828" viewBox="0 0 14.828 14.828">
                      <path id="Caminho_8519" data-name="Caminho 8519" d="M978,2308l-12,12m0-12,12,12" transform="translate(-964.586 -2306.586)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                    </svg></div>
                    </div>
              <p>Informe seus dados para ser avisado quando ele voltar ao estoque.</p>
              <form
                data-wsjs-contact="container"
                onsubmit="return wsMain.modules['pag-contact'].sendContactForm()"
              >
                <fieldset class="contact-form-top">
                  <div data-wsjs-error-message="Preenchimento obrigat&oacute;rio.">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"/></svg>
                    <input
                      id="nameform"
                      data-wsjs-contact="Nome"
                      type="text"
                      maxlength="50"
                      required
                      placeholder="Digite seu nome"
                    />
                  </div>
                  <div data-wsjs-error-message="Preenchimento obrigat&oacute;rio.">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"></path></svg>
                    <input
                      id="emailform"
                      data-wsjs-contact="E-mail"
                      type="email"
                      maxlength="50"
                      required
                      placeholder="Digite seu e-mail"
                    />
                  </div>
                </fieldset>
                <fieldset class="contact-form-bottom">
                  <input class="button-third" type="submit" value="Ativar aviso" />
                </fieldset>
              </form>
            </div>
          </div>
        </div>
    `

    document.body.appendChild(modal);
  }

  function unavaliableBtn() {
    const allUnavaliableProds = document.querySelectorAll(
      ".prod-showcase-holder.unavaliable"
    );

    allUnavaliableProds.forEach((prod) => {
      const btn = document.createElement("div");
      btn.classList.add("unavaliable-notify-wrapper");
      btn.innerHTML = `
              <div class="unavaliable-notify-wrapper__btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23" fill="none">
                  <path d="M7.34992 20.621C8.08224 21.2655 9.02438 21.621 9.99994 21.621C10.9755 21.621 11.9176 21.2655 12.65 20.621M15.9999 7.621C15.9999 6.0297 15.3678 4.50354 14.2426 3.37833C13.1174 2.25311 11.5912 1.621 9.99994 1.621C8.40864 1.621 6.88248 2.25311 5.75727 3.37833C4.63205 4.50354 3.99994 6.0297 3.99994 7.621C4.0841 9.93583 3.51208 12.2274 2.34992 14.2311C1.91209 14.8294 1.54628 15.4772 1.25995 16.161C1.25868 16.2333 1.27647 16.3046 1.31159 16.3678C1.3467 16.431 1.39785 16.4838 1.4599 16.5209C2.095 16.6475 2.74517 16.6813 3.38996 16.621H16.6099C17.2547 16.6813 17.9049 16.6475 18.54 16.5209C18.602 16.4838 18.6532 16.431 18.6883 16.3678C18.7234 16.3046 18.7412 16.2333 18.7399 16.161C18.4536 15.4772 18.0878 14.8294 17.65 14.2311C16.4878 12.2274 15.9158 9.93583 15.9999 7.621Z" stroke="#4AA9C2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg> 
                  <p>avise-me</p>
              </div>
              `;

      btn.addEventListener("click", openModal);

      prod.appendChild(btn);
   
    });

    const pagProdUnavaliableBtn = document.querySelector('.unavaliable-notify-wrapper__btn')

    if(!pagProdUnavaliableBtn) return

    pagProdUnavaliableBtn.addEventListener("click", (e) => {
      openModal(false, wsMain?.globalData?.infoProduto)
    })
  }

  function openModal(event, customData) {
    const modal = document.querySelector(".custom-modal-unavaliable");
    modal.classList.add("active-custom-modal-unavaliable");
    modal.classList.remove("custom-modal-unavaliable-hidding");
    
    let prodHolder
    
    if(event) {
      prodHolder = findProdShowcaseHolder(event);
    }

    if (!prodHolder && !customData) return;

    console.log('customData: ', customData)
    let img

    if(prodHolder) {
      img = prodHolder.querySelector(".prod-showcase-image img");
    }

    const imgContainer = modal.querySelector(".form__image-container");

    if (img) {
      const cloneImg = img.cloneNode(true);
      imgContainer.innerHTML = "";

      imgContainer.appendChild(cloneImg);
    }

    if(customData?.fotos && Array.isArray(customData?.fotos) && customData?.fotos.length) {
      const [foto] = customData?.fotos

      if(foto) {
        const imgElm = document.createElement('img')
        imgElm.alt = 'Imagem do produto'
        imgElm.src = foto.normal
        imgContainer.appendChild(imgElm)
      }
    }

    let name
    
    if (prodHolder) {
      name = prodHolder.querySelector(
        ".prod-showcase-info .prod-showcase-info-name p"
      ).textContent;
    }

    if(customData) {
      name = customData.nome
    }

    const nameContainer = modal.querySelector(".form__form-container h3");

    nameContainer.innerHTML = `O item ${name} está indisponível no momento.`;
  }

  function findProdShowcaseHolder(event) {
    let currentElement = event.target;
    let depth = 0;

    while (currentElement && depth < 30) {
      if (
        currentElement.classList &&
        currentElement.classList.contains("prod-showcase-holder")
      ) {
        return currentElement;
      }
      currentElement = currentElement.parentNode;
      depth++;
    }

    return false;
  }

  function handleCloseModal() {
    const closeBtn = document.querySelector(
      ".modal-unavaliable__content__close"
    );
    closeBtn.addEventListener("click", () => {
      const modal = document.querySelector(".custom-modal-unavaliable");
      modal.classList.add("custom-modal-unavaliable-hidding");
      setTimeout(() => {
        modal.classList.remove("active-custom-modal-unavaliable");
      }, 400);
    });
  }

  createCustomUnavaliableModal();
  unavaliableBtn();
  handleCloseModal();
}

function stepper(btn) {
  let inpt = btn.parentNode.parentNode.querySelector("input");

  btn.getAttribute("button-stepper") == "increment"
    ? inpt.stepUp()
    : inpt.stepDown();
}

try {
  isReady("product-list", customUnavaliable);
} catch (error) {}